module.exports = __webpack_public_path__ + "static/media/check_gradient.ec96681e.png";